import React, { useEffect, useRef, useState } from "react";
import loadable from "@loadable/component";
const LoadScript = loadable(() => import("./react-google-maps-loadscript.js"));
const GoogleMap = loadable(() => import("./react-google-maps-googlemap.js"));
const Marker = loadable(() => import("./react-google-maps-marker.js"));
import PropTypes from "prop-types";
import { ConsentContext } from "./layout.js";

const Map = ({ style, center, zoom }) => {
  const ref = useRef();
  const [isVisible, setVisible] = useState(false);
  const { consent, updateConsent } = React.useContext(ConsentContext);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
        }
      },
      { rootMargin: "0px 0px 200px 0px" }
    );
    ref && observer.observe(ref.current);
  }, []);

  const onLoad = React.useCallback(function callback() {}, []);

  const onUnmount = React.useCallback(function callback() {}, []);

  return consent.googleMaps && isVisible ? (
    <LoadScript
      id="google-map-script"
      googleMapsApiKey={process.env.GATSBY_GOOGLE_MAPS_API_KEY}
    >
      <GoogleMap
        mapContainerStyle={style}
        center={center}
        zoom={zoom}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        <>
          {" "}
          <Marker position={center} />
        </>
      </GoogleMap>
    </LoadScript>
  ) : (
    <div ref={ref} style={{ textAlign: "center" }}>
      <>
        <p>
          Kartet er ikke lastet, vennligst åpne koordinatene{" "}
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${center.lat},${center.lng}`}
            target="_blank"
            rel="noreferrer"
          >{`${center.lat}, ${center.lng}`}</a>{" "}
          i Google Maps eller lignende.
        </p>
        {!consent.googleMaps && updateConsent && (
          <>
            <p>Trenger samtykke til å laste inn kart.</p>
            <p>
              <button
                className="button"
                onClick={() => updateConsent({ googleMaps: true })}
              >
                Jeg samtykker
              </button>
            </p>
          </>
        )}
      </>
    </div>
  );
};

export default Map;

Map.propTypes = {
  style: PropTypes.object,
  center: PropTypes.object,
  zoom: PropTypes.number,
};
